import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from '@askporter/config-provider';
import { captureException } from '@askporter/exception-logger';
import { useToast } from '@askporter/toast';
import { copyToClipboard } from '@askporter/utils';
import { useBreadcrumbs } from '../../providers/breadcrumbs/BreadcrumbContext';
import { Breadcrumbs } from '../../stories/Breadcrumbs';
import { generateBreadcrumbItems } from './utils';

export const GlobalBreadcrumbs: React.FC = () => {
  const { displayRoute, navigationRoute, injectedBreadcrumbs, loadingUids, concealedSections, uidToRefMapping } =
    useBreadcrumbs();
  const location = useLocation();
  const basePath = location.pathname.split('/').filter(Boolean).join('/');
  const { showSuccess, showError } = useToast();
  const { t } = useTranslation();

  const copyFunction = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    const success = copyToClipboard(`${window.location.origin}/${basePath}`, captureException);
    if (success) {
      showSuccess(t('common:clipboard_success'));
    } else {
      showError(t('common:clipboard_error'));
    }
  };

  const copyRefFunction = (ref: string) => {
    const success = copyToClipboard(ref, captureException);
    if (success) {
      showSuccess(t('common:reference_clipboard_success'));
    } else {
      showError(t('common:clipboard_error'));
    }
  };

  const items = useMemo(() => {
    return generateBreadcrumbItems({
      displayRoute,
      navigationRoute,
      injectedBreadcrumbs,
      loadingUids,
      concealedSections,
      t,
      uidToRefMapping,
    });
  }, [displayRoute, navigationRoute, injectedBreadcrumbs, loadingUids, concealedSections, t, uidToRefMapping]);

  // atm we don't want to show breadcrumbs on assets list or task list pages
  return (
    <>
      {items.length >= 2 && (
        <Breadcrumbs
          items={items}
          highlightLastItem
          onCopy={copyFunction}
          onCopyRef={copyRefFunction}
          copyRefLabel={t('common:copy_reference')}
          t={t}
        />
      )}
    </>
  );
};
